import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { IGeneralReducerProps } from '@common/interface';

export const initialState: IGeneralReducerProps = {
	isLogin: false,
};

export const generalSlice = createSlice({
	name: 'General',
	initialState,
	reducers: {
		login: (state, action) => {
			state.isLogin = action.payload.isLogin;
		},
		logout: () => initialState,
	},
});

export const { login, logout } = generalSlice.actions;

export const selectGeneral = (state: RootState) => state.general;

export default generalSlice.reducer;
